import styled from 'styled-components';

export const CalendarPanelSC = styled.div`
  width: fit-content;
  display: flex;
  flex-direction: column;

  border-radius: ${({ theme }) => theme.radius.small}px;
  background: ${({ theme }) => theme.color.surface.modal};
  box-shadow: ${({ theme }) => theme.shadows.medium};

  .content-wrapper {
    display: flex;
    flex-direction: row;

    .options-wrapper {
      min-width: 160px;
      padding: 16px 0;
      overflow-y: auto;
      border-right: 1px solid ${({ theme }) => theme.color.border.emphasis};
    }

    .calendars-wrapper {
      display: flex;
      flex-direction: row;
      gap: 8px;
      padding: 0 24px;
      padding-bottom: 16px;

      .has-footer & {
        padding-bottom: 8px;
      }
    }
  }

  .footer-wrapper {
    display: flex;
    flex-direction: row;

    .has-footer & {
      min-height: 0px;
      border-top: 1px solid ${({ theme }) => theme.color.border.emphasis};
    }
  }
`;
